import { useState } from 'react';
import './Resetpassword.css'
import axios from 'axios'
import { useParams } from 'react-router-dom';




const ResetPassword = () => {
    const [password, SetPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [errors, setErrors] = useState(null)
    const { token } = useParams();


    const handleReset = async (e) => {
        e.preventDefault()
        try {
            if (password !== confirmPassword) {
                console.log(password, confirmPassword)
                setErrors('invalid Confirm Password')
                return
            }

            e.preventDefault();
            console.log(password, confirmPassword)
            const response = await axios.post(`https://backend.lexpediagroup.xyz/api/v1/reset-password/user/${token}`, { psd: confirmPassword })
            if (response.data.success) {
                setErrors('!Password Changed successfully')
            }
        } catch (err) {
            setErrors(err.response.data.message || 'invalid Request')
        }
    }


    return (
        <div className="_ResetPassword_Container">
            <form onSubmit={handleReset}>
                <p>{errors}</p>

                <label htmlFor="password">New PassWord</label>
                <input type="text" id="password" value={password} onChange={(e) => SetPassword(e.target.value)} />
                <br />
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />

                <button type="submit">Submit</button>
            </form>
        </div>
    )
}

export default ResetPassword